/*
 * @Author: Zhushitao
 * @Date: 2021-04-09 17:34:43
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-09 15:11:47
 * @Description: Exception Code
 */

export enum ERROR_TYPE {
  AUTH_ERROR = 'AUTH_ERROR', //Authentication failed
  GET_CONFIG_ERROR = 'GET_CONFIG_ERROR', //Get IM configuration
  GET_TOKEN_ERROR = 'GET_TOKEN_ERROR', //Failed to get Token
  SEND_IN_CLOSE_DIALOG_ERROR = 'SEND_IN_CLOSE_DIALOG_ERROR', //Failed to send message in end session
  SEND_FILE_MESSAGE_ERROR = 'SEND_FILE_MESSAGE_ERROR', // Failed to send file message
  SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR', // Failed to send file message
  CREATE_DIALOG_ERROR = 'CREATE_DIALOG_ERROR', //Failed to create session
  QUEUE_ERROR = 'QUEUE_ERROR', //Queuing error
  CLEAR_QUEUE_ERROR = 'CLEAR_QUEUE_ERROR', //Queuing error
  HEART_ERROR = 'HEART_ERROR',
  CREATE_IMCLOUD_ERROR = 'CREATE_IMCLOUD_ERROR', //IMCLOUD initialization failed
  DIALOG_NOT_IN_LOCAL = 'DIALOG_NOT_IN_LOCAL', //No session locally

  SOCKET_CONNECT_DIS = 'SOCKET_CONNECT_DIS', // Long chain disconnected
  IMSDK_ERROR = 'IMSDK_ERROR', // Long chain error

  IMCLOUD_NO_PUSH = 'IMCLOUD_NO_PUSH', // Imcloud did not push session

  NET_ERROR = 'NET_ERROR', // HTTP exception
  NET_ERROR_401 = 'NET_ERROR_401', // HTTP exception
}
